module.exports = __webpack_public_path__ + "../public/img/drink.77c4d7ac.png";